// import React from "react";
// import Footer from "./Essentials/Footer";
// import Navbar from "./Essentials/Navbar";
// import "./Css/Projects.css";
// import { useLocation } from "react-router-dom";
// import { Bar } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from 'chart.js';

// // Register the necessary Chart.js modules
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// const Projects = () => {
//   const router = useLocation();
//   const [year, setYear] = React.useState([]);
//   const [project, setProject] = React.useState([]);
//   React.useEffect(() => {
//     if (router.pathname.replace("/", "") == "nfrac_projects" && window.screen.width > 750) {
//       document.getElementById(
//         router.pathname.replace("/", "")
//       ).style.backgroundColor =
//         "#032848";
//     }

//     fetch("https://rohitpidishetty.github.io/NFRAC_Projects/Projects.json")
//       .then(res => res.json())
//       .then(projects => {
//         var ProjectsByYear = [];
//         var projectCountByYear = [];
//         var tot = 0;
//         Object.values(projects).forEach(data => {
//           ProjectsByYear.push(Object.values(data));
//           var count = ProjectsByYear[ProjectsByYear.length - 1].length;
//           projectCountByYear.push(count);
//           tot += count;
//         });
//         var years = Object.keys(projects);
//         var count = projectCountByYear;
//         setProject(count);
//         setYear(years);
//         tot -= 1;


//         var p26 = "";
//         ProjectsByYear[7].forEach(p => {
//           p26 += `<div
//         onclick="${"launch(" + "'" + p.link + "'" + ")"}"
//         id="projectDetails" data=${p.link}>
//         <img className="Language_icon" src=${p.image}>
//         <span><p>&nbsp;${p.title}</p></span>
//         </div>`;
//         });
//         document.getElementById("26data").innerHTML = p26;

//         document.getElementById("total").innerHTML =
//           tot + " Projects completed!!!";


//         var p19 = "";
//         ProjectsByYear[0].forEach(p => {
//           p19 += `<div
//         onclick="${"launch(" + "'" + p.link + "'" + ")"}"
//            id="projectDetails" data=${p.link}>
//         <img className="Language_icon" src='projects/${p.image}'>
//         <span><p>&nbsp;${p.title}</p></span>
//         </div>`;
//         });
//         document.getElementById("19data").innerHTML = p19;


//         var p20 = "";
//         ProjectsByYear[1].forEach(p => {
//           p20 += `<div
//         onclick="${"launch(" + "'" + p.link + "'" + ")"}"
//         id="projectDetails" data=${p.link}>
//         <img className="Language_icon" src='projects/${p.image}'>
//         <span><p>&nbsp;${p.title}</p></span>
//         </div>`;
//         });
//         document.getElementById("20data").innerHTML = p20;

//         var p21 = "";
//         ProjectsByYear[2].forEach(p => {
//           p21 += `<div
//         onclick="${"launch(" + "'" + p.link + "'" + ")"}"
//         id="projectDetails" data=${p.link}>
//         <img className="Language_icon" src='projects/${p.image}'>
//         <span><p>&nbsp;${p.title}</p></span>
//         </div>`;
//         });
//         document.getElementById("21data").innerHTML = p21;


//         var p22 = "";
//         ProjectsByYear[3].forEach(p => {
//           p22 += `<div
//         onclick="${"launch(" + "'" + p.link + "'" + ")"}"
//         id="projectDetails" data=${p.link}>
//         <img className="Language_icon" src='${p.image}'>
//         <span><p>&nbsp;${p.title}</p></span>
//         </div>`;
//         });
//         document.getElementById("22data").innerHTML = p22;

//         var p23 = "";
//         ProjectsByYear[4].forEach(p => {
//           p23 += `<div
//         onclick="${"launch(" + "'" + p.link + "'" + ")"}"
//         id="projectDetails" data=${p.link}>
//         <img className="Language_icon" src=${p.image}>
//         <span><p>&nbsp;${p.title}</p></span>
//         </div>`;
//         });
//         document.getElementById("23data").innerHTML = p23;


//         var p24 = "";
//         ProjectsByYear[5].forEach(p => {
//           p24 += `<div
//         onclick="${"launch(" + "'" + p.link + "'" + ")"}"
//         id="projectDetails" data=${p.link}>
//         <img className="Language_icon" src=${p.image}>
//         <span><p>&nbsp;${p.title}</p></span>
//         </div>`;
//         });
//         document.getElementById("24data").innerHTML = p24;


//         var p25 = "";
//         ProjectsByYear[6].forEach(p => {
//           p25 += `<div
//         onclick="${"launch(" + "'" + p.link + "'" + ")"}"
//         id="projectDetails" data=${p.link}>
//         <img className="Language_icon" src=${p.image}>
//         <span><p>&nbsp;${p.title}</p></span>
//         </div>`;
//         });

//         document.getElementById("25data").innerHTML = p25;



//       });


//   }, []);
//   const data = {
//     labels: year,
//     datasets: [
//       {
//         label: "Yearly Data",
//         data: project,
//         backgroundColor: [
//           "#0266FF",
//         ],
//         borderColor: [
//           "#0266FF",
//         ],
//         borderWidth: 1,
//       },
//     ],
//   };
//   const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         display: true,
//         position: "top",
//       },
//       tooltip: {
//         enabled: true,
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         title: {
//           display: true,
//           text: "Number of projects",
//         },
//       },
//       x: {
//         title: {
//           display: true,
//           text: "Projects",
//         },
//       },
//     },
//   };


//   return (
//     <>
//       <Navbar />
//       <div style={{
//         width: window.screen.width > 750 ? "50%" : "100%"
//       }}>
//         <Bar data={data} options={options} />
//       </div>
//       {
//         project &&
//         <center id="projects">
//           <p style={{
//             color: "#024369",
//             fontSize: "1.3rem"
//           }} id="first" className="heading">
//             2019 Projects
//           </p>
//           <center id="19data" />
//           <p style={{
//             color: "#024369",
//             fontSize: "1.3rem"
//           }} className="heading">2020 Projects</p>
//           <center id="20data" />
//           <p style={{
//             color: "#024369",
//             fontSize: "1.3rem"
//           }} className="heading">2021 Projects</p>
//           <center id="21data" />
//           <p style={{
//             color: "#024369",
//             fontSize: "1.3rem"
//           }} className="heading">2022 Projects</p>
//           <center id="22data" />
//           <p style={{
//             color: "#024369",
//             fontSize: "1.3rem"
//           }} className="heading">2023 Projects</p>
//           <center id="23data" />
//           <p style={{
//             color: "#024369",
//             fontSize: "1.3rem"
//           }} className="heading">2024 Projects</p>
//           <center id="24data" />
//           <p style={{
//             color: "#024369",
//             fontSize: "1.3rem"
//           }} className="heading">2025 Projects</p>
//           <center id="25data" />
//           <p style={{
//             color: "#024369",
//             fontSize: "1.3rem"
//           }} className="heading">2026 Projects</p>
//           <center id="26data" />
//           <br />
//           <br />
//           <center className="show" id="total" />
//           <Footer />
//         </center>
//       }
//     </>
//   );
// };
// export default Projects;




// V1

import React, { useEffect, useState } from "react";
import Footer from "./Essentials/Footer";
import Navbar from "./Essentials/Navbar";
import "./Css/Projects.css";
import { useLocation } from "react-router-dom";
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register the necessary Chart.js modules
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Projects = () => {
  const router = useLocation();
  const [year, setYear] = React.useState([]);
  const [project, setProject] = React.useState([]);
  const [count, setCount] = useState(null);
  const [pop, setPop] = useState(false);

  async function loadProjects() {
    const years = ['2019', '2020', '2021'];
    try {
      let res = await fetch("https://rohitpidishetty.github.io/NFRAC_Projects/Projects.json");
      res = await res.json();
      var keys = Object.keys(res);
      keys = keys.sort((a, b) => parseInt(b) - parseInt(a));

      var xAxis = [];
      for (var key of keys) {
        xAxis.push(key.toString());
        let projects = Object.values(res[key]);
        setProject((project) => [...project, projects.length]);
        setCount(count => count + projects.length);
        var div = document.createElement("div");
        var p = document.createElement("p");
        p.setAttribute("class", "heading");
        p.setAttribute("style", "color: rgb(2, 67, 105); font-size: 1.3rem; text-align:center; background-color:#F5F5F7");
        p.innerText = key + " Projects";
        document.getElementById("projects").appendChild(p);
        div.setAttribute("class", "card-container");
        for (const project of projects) {
          const card = document.createElement("div");
          card.setAttribute("class", "project-card");
          card.addEventListener("click", function () {
            window.open(project.link, "_self");
          });
          const image = document.createElement("img");
          image.setAttribute("src", years.includes(key) ? "projects/" + project.image : project.image);
          card.appendChild(image);
          const p = document.createElement("p");
          p.innerText = project.title;
          card.appendChild(p);
          div.appendChild(card);
        }
        document.getElementById("projects").appendChild(div);
      }

      setYear(xAxis);
      // console.log(year)
      setPop(true);
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => { loadProjects(); }, []);

  React.useEffect(() => {
    if (router.pathname.replace("/", "") == "nfrac_projects" && window.screen.width > 750) {
      document.getElementById(
        router.pathname.replace("/", "")
      ).style.backgroundColor =
        "#032848";
    }
  }, []);


  const PopUp = () => {
    return (
      <div className="popup">
        {count} projects completed ! 🎉
      </div>
    )
  }

  const data = {
    labels: year,
    datasets: [
      {
        label: "Yearly Data",
        data: project,
        backgroundColor: [
          "#3d628c",
        ],
        borderColor: [
          "#3d628c",
        ],
        borderWidth: 0.8,
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Number of projects",
        },
      },
      x: {
        title: {
          display: true,
          text: "Projects",
        },
      },
    },
  };


  return (
    <>
      <Navbar />
      <PopUp />
      <div style={{
        width: window.screen.width > 750 ? "50%" : "100%"
      }}>
        <Bar data={data} options={options} />
      </div>

      <div id="projects">

      </div>

      <Footer />

    </>
  );
};
export default Projects;
